<bk-modal [title]="'Edit Venue'" (closed)="bsModalRef.hide()">
  <div class="text-end mb-2">
    <a [routerLink]="getCompanyBureauUrl('/tools/vendor/' + vendorId + '/agency')" bkButton kind="outlined" color="secondary" size="sm"
      (click)="bsModalRef.hide()">Tools Edit Venue</a>
  </div>
  <form #venueForm="ngForm" (ngSubmit)="venueForm.form.valid && onSubmit()">
    <app-vendor-edit-form #vendorEditForm [states]="states" [vendor]="vendor"
      [avEquipments]="avEquipments" [(selectedAvEquipments)]="selectedAvEquipments"></app-vendor-edit-form>
    <div class="form-group d-flex justify-content-end gap-2">
      <button type="button" bkButton kind="outlined" color="secondary" (click)="bsModalRef.hide()">Cancel</button>
      <button bkButton [disabled]="!venueForm.form.valid || !vendorEditForm.formGroup.valid">Save</button>
    </div>
  </form>
</bk-modal>
